// extracted by mini-css-extract-plugin
export default {"natificationTitle":"Natification_natificationTitle__Db2Fx","natificationTitleTexst":"Natification_natificationTitleTexst__dC4q-"};